import dayjs, { ConfigType } from 'dayjs';

/**
 * True when the event starts on a later calendar day than `now`. Such an event
 * has no sales to show, and a range ending today would start after it ends
 * (the analytics API rejects that with a 400).
 */
export const isEventNotStarted = (
  startDate?: ConfigType,
  now: ConfigType = new Date()
): boolean => !!startDate && dayjs(now).isBefore(dayjs(startDate), 'day');

/** True when both ends are set and the start falls on a later day than the end. */
export const isReversedDateRange = ([start, end]: [
  Date | null,
  Date | null,
]): boolean => !!start && !!end && dayjs(start).isAfter(dayjs(end), 'day');
